/**
 * 导出通用配置
 */
module.exports = {
  // 标题，此项修改后需要重启项目
  title: '大导航',
  // 网站标题
  siteTitle: '大导航',
  // 网站加载时显示的内容
  siteLoading: '正在为您加载系统资源，请稍后...',
  // 网站描述
  siteDescription:
    '大导航网站',
  // 网站关键字
  siteKeywords:
    '大导航网站',
  // 白名单配置，不用令牌就能访问
  whileList: ['/', '/login', '/about'],
  // 超级管理员
  superAdmin: 'superAdmin',
  // 所有权限
  allPermission: '*:*:*',
  // 备案号
  recordTitle: ''
}
